import { EAdminGrowthInvestmentCategoryType } from "../../Enum/EAdminGrowthInvestmentCategoryType"
import { ECommercialOriginType } from "../../Enum/ECommercialOriginType"

export class AdminGrowthInvestmentFilter {
  startDate?: string

  endDate?: string

  categoryType?: EAdminGrowthInvestmentCategoryType

  commercialOriginType?: ECommercialOriginType

  channelName?: string

  campaignName?: string

  constructor(data: Partial<AdminGrowthInvestmentFilter> = {}) {
    Object.assign(this, data)
  }
}
